import { APIs } from "../../../../../util/api/APIs";
import SafeairManager from "../../../../../util/api/SafeairManager";

export class CoordinatorService {
  static async listEmsUser() {
    const apiConfig = {
      api: APIs.EMS.ListEms,
      parameters: null,
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    console.log("response: ", response.data);
    return response.data;
  }

  static async assignEms(emsId, emergencyId) {
    const apiConfig = {
      api: APIs.MedicalEmergency.UpdateMedicalEmergencyFields,
      parameters: {
        "medical-emergency-id": emergencyId,
      },
      body: {
        assignedEms: emsId.toString(),
      },
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }
}
